function isMobile() {
    let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return flag;
}

$(function () {
        let timeId = null;
        $('[data-ug-copy-data]').click(function () {
            clearTimeout(timeId);
            timeId = setTimeout(() => {
                var copyText = $(this).attr('data-ug-copy-data');
                var input = document.createElement('input');
                input.setAttribute('value', copyText);
                document.body.appendChild(input);
                input.select();
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    $(this).text('コピーしました！');
                    setTimeout(() => {
                        $(this).text('コピー');
                    }, 2000)
                }
                document.body.removeChild(input);
            }, 200);
        });
    

})
